<form [formGroup]="salaryForm" (ngSubmit)="saveSalary(inProgress)">
    <div class=" modal-header">
        <h5 class="modal-title d-flex align-items-center">
            <i class="ri-money-rupee-circle-line me-1 font-20 text-primary"></i>{{salaryForm.value.id?'Update':'Add'}} Salary - {{context?.employeeName || salary.employeeName}}
        </h5>
        <button type="button" class="btn-close text-end" data-bs-dismiss="modal" aria-label="Close"
            (click)="activeModal.close('Close')"></button>
    </div>
    <div class="modal-body">
        <div class="row g-3 mb-2">
            <div class="col-md-4">
                <label for="frequency" class="form-label">Frequency <b class="text-secondary">*</b></label>
                <div class="input-group">
                    <span class="input-group-text bg-transparent border-end-0"><i class='bx bx-server'></i></span>
                    <ng-select class="form-control rcx-ng-select" formControlName="frequency" ngbAutofocus
                        placeholder="Select Frequency" [ngClass]="{'is-invalid': submitted && f.frequency.errors}"
                        [clearable]="false">
                        <ng-option *ngFor=" let frequency of frequencies;" [value]="frequency">{{frequency}}</ng-option>
                    </ng-select>
                    <div class="invalid-feedback" *ngIf="submitted && f.frequency.errors">
                        <span *ngIf="f.frequency.errors.required">Please select a frequency.</span>
                        <span *ngIf="f.frequency.errors.pattern">Only letters are allowed.</span>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <label for="date" class="form-label">Start Date<b class="text-secondary">*</b></label>
                <div class="input-group"> <span class="input-group-text bg-transparent  border-end-0"><i
                            class='bx bx-calendar'></i></span>
                    <input type="date" class="form-control ps-1" id="date" formControlName="fromDate"
                      [ngClass]="{'is-invalid': submitted && f.fromDate.errors}" />
                    <div class="invalid-feedback" *ngIf="submitted && f.fromDate.errors">
                        <span *ngIf="f.fromDate.errors.required">Please select a from Date.</span>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <label for="date" class="form-label">End Date<b class="text-secondary">*</b></label>
                <div class="input-group"> <span class="input-group-text bg-transparent  border-end-0"><i
                            class='bx bx-calendar'></i></span>
                    <input type="date" class="form-control ps-1" id="date" formControlName="toDate"
                        [min]="salaryForm.value.fromDate" [disabled]="!salaryForm.value.fromDate"
                        [ngClass]="{'is-invalid': submitted && f.toDate.errors}" />
                    <div class="invalid-feedback" *ngIf="submitted && f.toDate.errors">
                        <span *ngIf="f.toDate.errors.required">Please select a to Date.</span>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <label for="basicSalary" class="form-label">Basic Salary<b class="text-secondary">*</b></label>
                <div class="input-group"> <span class="input-group-text bg-transparent border-end-0"><i
                            class='bx bx-wallet'></i></span>
                    <input type="number" class="form-control ps-1" id="basicSalary" placeholder="Enter basic Salary "
                        [ngClass]="{'is-invalid': submitted && f.basicSalary.errors}" formControlName="basicSalary"
                        autocomplete="off" />
                    <div class="invalid-feedback" *ngIf="submitted && f.basicSalary.errors">
                        <span *ngIf="f.basicSalary.errors.required ||f.basicSalary.errors.pattern">Please enter a valid
                            basic Salary..</span>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <label for="providentFund" class="form-label">Provident Fund</label>
                <div class="input-group">
                    <span class="input-group-text bg-transparent border-end-0"><i class='bx bx-wallet'></i></span>
                    <ng-select class="form-control rcx-ng-select" formControlName="providentFundId"
                        placeholder="Select provident Fund"
                        [ngClass]="{'is-invalid': submitted && f.providentFundId.errors}" [clearable]="false">
                        <ng-option *ngFor=" let providentFund of providentFunds;"
                            [value]="providentFund.id">{{providentFund.name}}</ng-option>
                    </ng-select>
                    <div class="invalid-feedback" *ngIf="submitted && f.providentFundIderrors">
                        <span *ngIf="f.providentFundId.errors.required">Please select a provident Fund.</span>
                        <span *ngIf="f.providentFundId.errors.pattern">Only letters are allowed.</span>
                    </div>
                </div>
            </div>
            <div class="col-md-auto">
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="active" formControlName="active">
                    <label class="form-check-label" for="prime">Active</label>
                </div>
            </div>
            <div class="col-lg-auto ms-auto">
                <button type="submit" class="btn btn-secondary rcx-btn" #inProgress
                    [ngClass]="{'no-event':inProgress?.value=='true'}">
                    <ng-container *ngIf="inProgress?.value=='true'">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        {{salaryForm.value.id?'Updating...':'Saving...'}}
                    </ng-container>
                    <ng-container *ngIf="inProgress?.value!='true'">
                        <i class="bx bx-save"></i>{{salaryForm.value.id?'Save Changes':'Save'}}
                    </ng-container>
                </button>
            </div>
        </div>
    </div>
</form>
<section class="rcx-table">
    <div class="row">
        <div class="col-lg-12">
            <div class="card btr">
                <div class="card-content">
                    <div class="card-body table-responsive">
                        <form [formGroup]="salaryParticularForm" *ngIf="salaryForm?.value?.id">
                            <table class="table" id="table">
                                <thead id="table-thead">
                                    <tr class="bg-light">
                                        <th scope="col" width="70">Particular</th>
                                        <th scope="col" width="300">Amount</th>
                                        <th scope="col" width="300">Disabled</th>
                                        <th scope="col" width="160" class="text-center">Actions</th>
                                    </tr>
                                </thead>
                                <tbody formArrayName="salaryParticulars">
                                    <tr *ngFor="let salaryParticular of salaryParticulars.controls; let i=index"
                                        [formGroupName]="i">
                                        <td class="col-lg-4 px-0">
                                            <ng-select [items]="particulars" bindLabel="name" bindValue="id"
                                                placeholder="Choose..." formControlName="particularId"
                                                [clearable]="false" [searchable]="true"
                                                [ngClass]="{'is-invalid': submittedParticular && salaryParticular.get('particularId')?.invalid}">
                                            </ng-select>
                                            <div class="invalid-feedback"
                                                *ngIf="submittedParticular && salaryParticular.get('particularId')?.invalid">
                                                <span
                                                    *ngIf="salaryParticular.get('particularId')?.errors?.required">Please
                                                    select a valid particular.</span>
                                            </div>
                                        </td>
                                        <td class="col-lg-4">
                                            <input type="number" class="form-control" formControlName="value"
                                                placeholder="Amount" required
                                                [ngClass]="{'is-invalid': submittedParticular && salaryParticular.get('value')?.invalid}">
                                            <div class="invalid-feedback"
                                                *ngIf="submittedParticular && salaryParticular.get('value')?.invalid">
                                                <span *ngIf="salaryParticular.get('value')?.errors?.required">Please
                                                    enter a valid amount.</span>
                                                <span *ngIf="salaryParticular.get('value')?.errors?.min">Amount must be
                                                    greater than {{minAmount}}.</span>
                                            </div>
                                        </td>
                                        <td class="col-lg-4">
                                            <input type="checkbox" formControlName="disabled" class="form-check-input">
                                            <label class="form-check-label ms-2">Disabled</label>
                                        </td>
                                        <td class="text-center">
                                            <div class="d-flex justify-content-center align-items-center">
                                                <button type="submit"
                                                    (click)="upsertSalaryParticular(salaryParticular, i)"
                                                    class="btn btn-secondary btn-sm me-2">
                                                    <i class="{{ salaryParticular?.value?.id ? 'bx bx-edit' : 'bx bx-plus' }}"
                                                        title="{{ salaryParticular?.value?.id ? 'Edit Salary Particular' : 'Add Salary Particular' }}">
                                                    </i>
                                                </button>
                                                <button type="button" class="btn btn-danger btn-sm"
                                                    (click)="deleteSalaryParticular(i)">
                                                    <i class="bx bx-trash" title="Delete Salary Particular"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
      <!-- Total Amount Display -->
      <div class="row mt-3">
        <div class="col-12 text-center mt">
            <h6 class="text-danger">Total Salary: {{ totalSalary | number:'1.2-2' }}</h6>
        </div>
    </div>
</section>